import { Link, MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Actions from "../../redux/Actions";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {openFileDownload} from "../../utils/Utils";

export interface SdsBlankCsvDownloadProps {
    schoolCode: string;
    tenantId: string;

    apiService: ApiService;
}

export interface SdsBlankCsvDownloadState {

}

class SdsBlankCsvDownload extends Component<SdsBlankCsvDownloadProps & DispatchProps, SdsBlankCsvDownloadState> {

    constructor(props: SdsBlankCsvDownloadProps & DispatchProps) {
        super(props);

        this.state = { };
    }
    
    private getCSV = async () => {
        try {
            const result = await this.props.apiService.getSdsCSVBlank(this.props.tenantId, this.props.schoolCode);

            await openFileDownload(result)
            
            this.props.dispatch(Actions.showMessageBar(`Succesfully got CSVs`, MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error getting CSVs`, MessageBarType.error));
        }
    }

    public render() {
        return (
            <Fragment>
                <Link onClick={this.getCSV}>
                    Download blank set of CSVs for this school (for SDS profile creation)
                </Link>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { schoolCode: string, tenantId: string}): SdsBlankCsvDownloadProps => {

        return {
            schoolCode: ownProps.schoolCode,
            tenantId: ownProps.tenantId,
            apiService: state.auth.apiService
        };
    }
)(SdsBlankCsvDownload);